import { SearchLoadingView } from "../Loading/Loading";


interface SearchFieldProps {
    setSearch: (search: any) => void;
    timeout: NodeJS.Timeout | undefined;
    placeholder?: string;
}


interface ElasticSearchFieldProps extends SearchFieldProps {
    className?: string;
}


export const SearchField = ({setSearch, timeout, ...props}: SearchFieldProps) => {
    return (
        <div className="field-wrapper flex align-center bg-primary r15 search-field" style={{height:'36px'}}>
            <svg className="search-icon" width="18" height="19" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.7723 22.3876L18.3527 17.9399C20.0007 16.0804 21.0245 13.6178 21.0245 10.9291C21.0245 5.12449 16.3302 0.400391 10.5622 0.400391C4.79425 0.400391 0.0999756 5.12449 0.0999756 10.9291C0.0999756 16.7337 4.79425 21.4578 10.5622 21.4578C12.6097 21.4578 14.5074 20.8548 16.1055 19.8496L20.6999 24.4732C20.9745 24.7496 21.3491 24.9004 21.7236 24.9004C22.0981 24.9004 22.4727 24.7496 22.7474 24.4732C23.3466 23.8953 23.3466 22.9655 22.7723 22.3876ZM3.02141 10.9291C3.02141 6.75783 6.3923 3.34039 10.5622 3.34039C14.7321 3.34039 18.078 6.75783 18.078 10.9291C18.078 15.1004 14.7072 18.5178 10.5622 18.5178C6.41727 18.5178 3.02141 15.1255 3.02141 10.9291Z" fill="#A8A8A8"/>
            </svg>
            <input onKeyUp={(e:any) => {setSearch(e.target.value)}} 
                className="p35px-left no-outline" 
                type="text" 
                placeholder={ props.placeholder 
                        ? props.placeholder
                        : 'Поиск'
                }
                style={{outline: 'none'}}    
            />
            { timeout !== undefined && SearchLoadingView()}
        </div>
    )
}


export const ElasticSearchField = ({setSearch, timeout, className, ...props}: ElasticSearchFieldProps) => {
    return (
        <div className={`flex align-center bg-primary r15 search-field ${className ? className : ''}`} style={{height:'36px'}}>
            <svg className="search-icon" width="18" height="19" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.7723 22.3876L18.3527 17.9399C20.0007 16.0804 21.0245 13.6178 21.0245 10.9291C21.0245 5.12449 16.3302 0.400391 10.5622 0.400391C4.79425 0.400391 0.0999756 5.12449 0.0999756 10.9291C0.0999756 16.7337 4.79425 21.4578 10.5622 21.4578C12.6097 21.4578 14.5074 20.8548 16.1055 19.8496L20.6999 24.4732C20.9745 24.7496 21.3491 24.9004 21.7236 24.9004C22.0981 24.9004 22.4727 24.7496 22.7474 24.4732C23.3466 23.8953 23.3466 22.9655 22.7723 22.3876ZM3.02141 10.9291C3.02141 6.75783 6.3923 3.34039 10.5622 3.34039C14.7321 3.34039 18.078 6.75783 18.078 10.9291C18.078 15.1004 14.7072 18.5178 10.5622 18.5178C6.41727 18.5178 3.02141 15.1255 3.02141 10.9291Z" fill="#A8A8A8"/>
            </svg>
            <input onKeyUp={(e:any) => {setSearch(e.target.value)}} 
                className="p35px-left no-outline full-width" 
                type="text" 
                placeholder={ props.placeholder 
                        ? props.placeholder
                        : 'Поиск'
                }
                style={{outline: 'none'}}    
            />
            { timeout !== undefined && SearchLoadingView()}
        </div>
    )
}